import React, { FunctionComponent, ReactNode } from "react";
import Spinner from "react-bootstrap/Spinner";

export const Carregant: FunctionComponent = () => (
  <Spinner animation="border" role="status">
    <span className="visually-hidden">Carregant...</span>
  </Spinner>
);